import { render, staticRenderFns } from "./CartItemsStep.vue?vue&type=template&id=516e939c&scoped=true&"
import script from "./CartItemsStep.vue?vue&type=script&lang=js&"
export * from "./CartItemsStep.vue?vue&type=script&lang=js&"
import style0 from "./CartItemsStep.vue?vue&type=style&index=0&id=516e939c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516e939c",
  null
  
)

export default component.exports